<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索：
                        <el-input placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option
                                        v-for="item in keywordList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                </div>
            </div>
            <div v-show="showFV" class="yx-flex-h-start" style="margin-top: 10px;">
                <div>
                    状态：
                    <el-select v-model="searchVal.agentStatId" placeholder="服务商状态" size="mini" clearable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in agentStatList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    等级：
                    <el-select v-model="searchVal.agentLevelId" placeholder="服务商等级" size="mini" clearable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in agentLevels"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    推荐人：
                    <el-select v-model="searchVal.agentPid" placeholder="服务商来源" size="mini" filterable  clearable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in agentFromList"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                        </el-option>
                    </el-select>
                </div>

                <!--
                <AreaSelect v-bind:title="'服务商:'" v-bind:inAreas="{}" v-bind:outAreas.sync="outAreas"></AreaSelect>
                <div class="mg-l10">
                    入库日期:
                    <el-date-picker
                            type="daterange"
                            size="mini"
                            unlink-panels
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </div>
                -->
            </div>
            <div class="yx-flex-h-start" style="margin-top: 10px;">
                <el-button type="danger" icon="el-icon-plus" @click="viewAdd">新增服务商</el-button>
                <el-button type="danger" icon="el-icon-user" @click="viewAdd">设置推荐人</el-button>
                <el-dropdown trigger="click" @command="changeAgentStatus">
                    <el-button type="danger" icon="el-icon-setting" @click="viewAdd">
                        设置状态 <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in agentStatList" :key=index :command="item.id">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>

        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="agents"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column prop="agentCode" label="服务商编号" width="100"></el-table-column>
                <el-table-column prop="agentName" label="服务商名称" width="200"></el-table-column>
                <el-table-column prop="agentStatus" label="状态" width="100" :formatter="funFmtAgentStatus"></el-table-column>
                <el-table-column prop="agentLevel.name" label="等级" width="100"></el-table-column>
                <el-table-column prop="agentPidName" label="推荐人" width="100"></el-table-column>
                <el-table-column prop="legalPerson" label="法人" width="100"></el-table-column>
                <el-table-column prop="linkMan" label="联系人" width="100"></el-table-column>
                <el-table-column prop="linkPhone" label="联系电话" width="100"></el-table-column>
                <el-table-column prop="cityIdName" label="城市" width="100"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="info" plain size="mini" style="padding: 5px" @click="viewEdit(scope.row)">编辑</el-button>
                        <el-button type="primary" plain size="mini" style="padding: 5px" @click="viewDetail(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="width: 1px" />
            <!--
            <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
            -->
            <el-pagination
                    background
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="sizes, prev, pager, next, jumper, ->, total, slot"
                    :total="total">
            </el-pagination>
        </div>


        <!-- 对话框 编辑 -->
        <el-dialog
                :title="titleDlg"
                :visible.sync="showDlg"
                :fullscreen=true
                :destroy-on-close=true
                class="dlg-normal">
            <div>
                <el-form :model="agentInfo" :rules="rules" ref="ruleForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="姓名A:" prop="agentName">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="agentInfo.agentName"
                                          placeholder="AAA"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="tipTitle">基本信息</div>
                    <table style="margin: auto">
                        <tr>
                            <td width="300px">
                                <el-tag class="txt-tag">服务商编号</el-tag> <el-input size="small" v-model="agentInfo.agentCode" :disabled="true" />
                            </td>
                            <td class="td-spa"/>
                            <td width="300px">
                                <el-tag class="txt-tag">服务商来源</el-tag> <el-input size="small" v-model="agentInfo.agentPidName" placeholder="推荐人"/>
                            </td>
                            <td class="td-spa"/>
                            <td width="500px">
                                <el-tag class="txt-tag">服务商名称</el-tag> <el-input size="small" v-model="agentInfo.agentName"/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-tag class="txt-tag">服务商性质</el-tag>
                                <el-select v-model="agentInfo.agentNatureId" size="mini"
                                           style="width: 100%;">
                                    <el-option
                                            v-for="item in agentNatures"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </td>
                            <td class="td-spa"/>
                            <td>
                                <el-tag class="txt-tag">服务商简称</el-tag> <el-input size="small" v-model="agentInfo.shortName"/>
                            </td>
                            <td class="td-spa"/>
                            <td>
                                <el-tag class="txt-tag">城市地区</el-tag> <AreaSelect v-if="areaRest" v-bind:inAreas="this.inAreas" v-bind:outAreas.sync="outAreas" />
                                <!--
                                <el-tag class="txt-tag">银行</el-tag> <BankSelect v-if="bankRest" v-bind:inCnapsCode="this.inCnapsCode" v-bind:outCnapsCode.sync="outCnapsCode" />
                                -->
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-tag class="txt-tag">联系人</el-tag> <el-input size="small" v-model="agentInfo.linkMan"/>
                            </td>
                            <td class="td-spa"/>
                            <td>
                                <el-tag class="txt-tag">联系电话</el-tag> <el-input size="small" v-model="agentInfo.linkPhone"/>
                            </td>
                            <td class="td-spa"/>
                            <td>
                                <el-tag class="txt-tag">详细地址</el-tag> <el-input size="small" v-model="agentInfo.addr"/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-tag class="txt-tag">电子邮箱</el-tag> <el-input size="small" v-model="agentInfo.linkMail"/>
                            </td>
                            <td class="td-spa"/>
                            <td>
                                <el-tag class="txt-tag-nu">营业执照编号</el-tag> <el-input size="small" v-model="agentInfo.licenseCode"/>
                            </td>
                            <td class="td-spa"/>
                            <td>
                                <el-tag class="txt-tag-nu">营业执照图片</el-tag> <el-input size="small" v-model="agentInfo.licenseCode"/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <el-tag class="txt-tag-nu">法人姓名</el-tag> <el-input size="small" v-model="agentInfo.legalPerson"/>
                            </td>
                            <td class="td-spa"/>
                            <td>
                                <el-tag class="txt-tag-nu">法人电话</el-tag> <el-input size="small" v-model="agentInfo.legalPhone"/>
                            </td>
                            <td class="td-spa"/>
                            <td>
                                <el-tag class="txt-tag-nu">法人身份证号</el-tag> <el-input size="small" v-model="agentInfo.legalIdcardNo"/>
                            </td>
                        </tr>
                    </table>
                    <el-divider></el-divider>
                    <div class="tipTitle">合同信息</div>
                    <table style="margin: auto">
                        <tr>
                            <td width="300px">
                                <el-tag class="txt-tag">合同编号</el-tag> <el-input size="small" v-model="agentInfo.contractNo"/>
                            </td>
                            <td class="td-spa"/>
                            <td width="300px">
                                <el-tag class="txt-tag">合同时间</el-tag>
                                <div class="yx-flex-h-between" >
                                    <el-col :span="11"><el-date-picker type="date" style="width: auto" placeholder="开始日期" v-model="agentInfo.contractBeg" /></el-col>
                                    <el-col :span="1" style="text-align: center;line-height: 30px;">-</el-col>
                                    <el-col :span="11"><el-date-picker type="date" style="width: auto" placeholder="结束日期" v-model="agentInfo.contractEnd" /></el-col>
                                </div>
                            </td>
                            <td class="td-spa"/>
                            <td width="500px">
                            </td>
                        </tr>
                    </table>
                    <el-divider></el-divider>
                    <div class="tipTitle">结算账户</div>
                    <table style="margin: auto">
                        <tr>
                            <td width="300px">
                                <el-tag class="txt-tag">账户类型</el-tag>
                                <el-select v-model="agentInfo.stlAccTypeId" size="mini"
                                           style="width: 100%;">
                                    <el-option
                                            v-for="item in settleAccTypes"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>

                            </td>
                            <td class="td-spa"/>
                            <td width="300px">
                                <el-tag class="txt-tag">银行编号</el-tag> <el-input size="small" v-model="agentInfo.stlBankCnapsCode"/>
                            </td>
                            <td class="td-spa"/>
                            <td width="500px">
                                <el-tag class="txt-tag">银行卡号</el-tag> <el-input size="small" v-model="agentInfo.stlAccNo"/>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5">
                                <el-tag class="txt-tag">开户银行</el-tag> <BankSelect v-if="bankRest" v-bind:inCnapsCode="this.inCnapsCode" v-bind:outCnapsCode.sync="outCnapsCode" />
                            </td>
                            <!--
                            <td width="300px">
                                <el-tag class="txt-tag">开户城市</el-tag> <el-input size="small" v-model="agentInfo.stlBankCity"/>
                            </td>
                            <td class="td-spa"/>
                            <td width="300px">
                                <el-tag class="txt-tag">开户总行</el-tag> <el-input size="small" v-model="agentInfo.stlBankName"/>
                            </td>
                            <td class="td-spa"/>
                            <td width="500px">
                                <el-tag class="txt-tag">开户支行</el-tag> <el-input size="small" v-model="agentInfo.stlBankBranch"/>
                            </td>
                            -->
                        </tr>
                        <tr>
                            <td width="300px">
                                <el-tag class="txt-tag">开户名称</el-tag> <el-input size="small" v-model="agentInfo.stlAccName"/>
                            </td>
                            <td class="td-spa"/>
                            <td width="300px">
                                <el-tag class="txt-tag">开卡手机号</el-tag> <el-input size="small" v-model="agentInfo.stlAccPhone"/>
                            </td>
                            <td class="td-spa"/>
                            <td width="500px">
                                <el-tag class="txt-tag">开卡身份证号</el-tag> <el-input size="small" v-model="agentInfo.stlAccIdcardNo"/>
                            </td>
                        </tr>
                    </table>
                    <el-divider></el-divider>
                    <div class="tipTitle">系统账号</div>
                    <table style="margin: auto">
                        <tr>
                            <td width="300px">
                                <el-tag class="txt-tag">主账号名称</el-tag> <el-input size="small" v-model="agentInfo.agentCode" />
                            </td>
                            <td class="td-spa"/>
                            <td width="300px">
                                <el-tag class="txt-tag">主账号</el-tag> <el-input size="small" v-model="agentInfo.agentName" placeholder="推荐人"/>
                            </td>
                            <td class="td-spa"/>
                            <td width="500px">
                                <el-tag class="txt-tag">登录密码</el-tag> <el-input size="small" v-model="agentInfo.agentName"/>
                            </td>
                        </tr>
                    </table>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showDlg = false">取 消</el-button>
                <el-button size="small" type="primary" @click="">确 定</el-button>
            </span>
        </el-dialog>

    </div>

</template>

<script>

    import {
        URL_AGENT_NATURES,
        URL_AGENT_LEVELS,
        URL_BANK_ACC_TYPES,
        URL_AREAS_PROV_CITY, URL_AGENT_FROMS
    } from "../../utils/cons";
    import AreaSelect from "../../components/pub/AreaSelect";
    import BankSelect from "../../components/pub/BankSelect";

    export default {
        name: "AgentInfo",
        components: {AreaSelect,BankSelect},
        data() {
            return {
                optionProps: {
                    value: 'id',
                    label: 'name',
                    children: 'children'
                },
                areaRest: true,
                bankRest: true,
                titleArea: '',
                titleDlg: '',
                showDlg: false,
                showFV: false,
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                agents: [],
                agentFromList: [],
                agentInfo: {
                    id: null,
                    agentCode: null,
                    agentName: null,
                    shortName: null,
                    provId: null,
                    provIdName: null,
                    cityId: null,
                    cityIdName: null,
                    distId: null,
                    distIdName: null,
                    townId: null,
                    townIdName: null,
                    addr: null,
                    tel: null,
                    linkMan: null,
                    linkPhone: null,
                    linkMail: null,
                    licenseCode: null,
                    licensePhoto: null,
                    legalPerson: null,
                    legalPhone: null,
                    legalIdcardNo: null,
                    legalIdcardPhoto: null,
                    contractNo: null,
                    contractBeg: null,
                    contractEnd: null,
                    agentFee: null,
                    recvAgentFee: null,
                    stlBankCnapsCode: null,
                    stlAccNo: null,
                    stlAccIdcardNo: null,
                    stlAccName: null,
                    stlAccPhone: null,
                    agentLevelId: null,
                    agentLevel: {id:null,name:null},
                    agentNatureId: null,
                    agentNature: {id:null,name:null},
                    stlAccTypeId: null,
                    settleAccType: {id:null,name:null},
                    agentPid: null,
                    agentPidName: null,
                    agentStatus: null,
                    remark: null
                },
                rules: {
                    agentName: [{required: true, message: '请输入服务商名称', trigger: 'blur'}],
                    stlAccIdcardNo: [{required: true, message: '请开户身份证号码', trigger: 'blur'}, {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '身份证号码格式不正确',
                        trigger: 'blur'
                    }],
                    linkMail: [{required: true, message: '请输入邮箱地址', trigger: 'blur'}, {
                        type: 'email',
                        message: '邮箱格式不正确',
                        trigger: 'blur'
                    }],
                },
                cityList:[],
                keywordList: [
                    {id:"agentName",name:"服务商名称"},
                    {id:"agentCode",name:"服务商编号"},
                    {id:"linkPhone",name:"联系电话"}
                    ],
                agentStatList:[{id:"0",name:"审核中"},{id:"1",name:"正常"},{id:"2",name:"冻结"},{id:"3",name:"注销"}],
                agentLevels: [],
                agentNatures: [],
                settleAccTypes: [],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    agentStatId: null,
                    agentLevelId: null,
                    agentPid: null
                },
                outAreas:{},
                inAreas:{},
                inCnapsCode:null,
                outCnapsCode:null
            }
        },
        mounted() {
            this.initAgents();
            this.getRequest(URL_AGENT_LEVELS).then(resp => { if (resp) this.agentLevels = resp.data });
            this.getRequest(URL_AGENT_NATURES).then(resp => { if (resp) this.agentNatures = resp.data });
            this.getRequest(URL_BANK_ACC_TYPES).then(resp => { if (resp) this.settleAccTypes = resp.data });
            this.getRequest(URL_AREAS_PROV_CITY).then(resp => { if (resp) this.cityList = resp.data  });
            this.getRequest(URL_AGENT_FROMS).then(resp => { if (resp) this.agentFromList = resp.data  });
        },
        methods: {
            handleChange(value) {
                console.log(value);
            },
            reloadArea () { // 重置组件
                this.areaRest = false;
                this.bankRest = false;
                this.$nextTick(() => (this.areaRest = true));
                this.$nextTick(() => (this.bankRest = true));
            },
            initAreaComp() { // 初始化组件传入参数
                // 将服务商表获取的区域3级ID赋予<区域组件>
                this.inAreas.provId = this.agentInfo.provId;
                this.inAreas.cityId = this.agentInfo.cityId;
                this.inAreas.distId = this.agentInfo.distId;
                this.inAreas.townId = this.agentInfo.townId;
                this.inAreas.provIdName = this.agentInfo.provIdName;
                this.inAreas.cityIdName = this.agentInfo.cityIdName;
                this.inAreas.distIdName = this.agentInfo.distIdName;
                this.inAreas.townIdName = this.agentInfo.townIdName;

                this.inCnapsCode = this.agentInfo.stlBankCnapsCode;

                this.reloadArea();
            },
            viewEdit(data) {
                this.titleDlg = '编辑服务商信息';
                Object.assign(this.agentInfo, data);
                this.initAreaComp();
                this.showDlg = true;
            },
            viewDetail(data) {
                this.titleDlg = '查看服务商信息';
                Object.assign(this.agentInfo, data);
                this.initAreaComp();
                this.showDlg = true;
            },
            viewAdd() {
                this.titleDlg = '新增服务商';
                this.agentInfo = {};
                this.initAreaComp();
                this.showDlg = true;
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.initAgents();
            },
            funFmtAgentStatus(row, column) {
                for(let i=0; i<this.agentStatList.length; i++) {
                    if(this.agentStatList[i].id==row.agentStatus) {
                        return this.agentStatList[i].name;
                    }
                }
                return row.id;
            },
            changeAgentStatus(command) {
                this.$message('click on item ' + command);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            initAgents() {
                this.loading = true;
                let url = '/agent/agentInfo?page=' + this.page + '&size=' + this.size;


                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.agentLevelId) {
                    url += '&agentLevelId=' + this.searchVal.agentLevelId;
                }
                if (this.searchVal.agentStatId) {
                    url += '&agentStatus=' + this.searchVal.agentStatId;
                }
                if (this.searchVal.agentPid) {
                    url += '&agentPid=' + this.searchVal.agentPid;
                }

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.agents = resp.data;
                        this.total = resp.total;
                    }
                })
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initAgents();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initAgents();
            },
            exportData() {
            }
        }

    }
</script>

<style scoped>

</style>
